<template>
	<div class="title-section">
		<span
			class="title-section-title"
			:class="{ 'title-section--admin': !$session.currentUser.clientId }"
			v-if="title"
			>{{ title }}</span
		>
		<span class="title-section-subtitle" v-if="subtitle">{{ subtitle }}</span>
	</div>
</template>

<script>
export default {
	name: 'TitleSection',

	props: {
		title: String,
		subtitle: String,
	},
};
</script>

<style lang="scss" scoped>
.title-section {
	&--admin {
		font-weight: 700 !important;
	}
	&-title {
		font-family: var(--v-font-base) !important;
		color: #2c3153;
		text-transform: uppercase;
		font-size: 18px;
		font-weight: 700;
		display: block;
	}

	&-subtitle {
		font-family: var(--v-font-base) !important;
		font-size: 13px;
		line-height: 13px;
		color: #9e9e9e;
		display: block;
		margin-top: 4px;
	}
}
</style>
